import React from 'react';
import { Col, Form } from 'react-bootstrap';

// SelectDropdown
const SelectDropdown = ({ c, i, valuesRequired, handleInputChange }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group controlId={'validationCustom' + i}>
        <Form.Label>
          {c.required ? c.name + ' *' : c.name + ' (opcional)'}
        </Form.Label>
        <Form.Control
          as="select"
          name={!c.required ? '_' + c.name : c.name}
          onChange={handleInputChange}
          required={c.required}
          defaultValue={'-1'}
          className="select-contact-form"
          isValid={
            (c.required &&
              valuesRequired.content[c.name] !== undefined &&
              valuesRequired.content[c.name].length > 2) ||
            (!c.required &&
              valuesRequired.content['_' + c.name] !== undefined &&
              valuesRequired.content['_' + c.name].length > 2)
          }
        >
          <option value="-1" disabled>
            {c.placeholder}
          </option>
          {c.dropdownOptions.map((e, index) => (
            <option value={e.option} key={'key_' + index + c.name}>
              {e.option}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Seleccione {c.name} por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default SelectDropdown;
